import analytics, { AnalyticsActionName } from '@utils/analytics';
import { getExternalIdsString } from '@utils/users';
import { useContext } from 'react';
import { ProjectContext } from 'routes/ProjectProvider';
import { AuthContext } from './useAuth';

const useAnalytics = () => {
	const {
		consoleUser: { externalIDs }
	} = useContext(AuthContext);
	const { currentProject, currentCompany } = useContext(ProjectContext);

	return (action: AnalyticsActionName, metadata: any = {}) => {
		analytics().track(action, {
			PID: currentProject,
			CID: currentCompany,
			UID: getExternalIdsString(externalIDs),
			metadata
		});
	};
};

export default useAnalytics;
